import { gql } from '@apollo/client';

export const GET_STATS = gql`
  query get_agent_stats($data: AgentStatsInputType) {
    get_agent_stats(data: $data) {
      hasError
      data
      message
    }
  }
`;
